import NumberFormat from 'react-number-format';

export default NumberFormat;
